import i18n from 'services/base/i18n';

export default {
  // Link to the user's account information page
  viewAndEdit: () => i18n.pgettext('Pages|Settings', 'View and edit account info'),
  // Label on the checkbox that decides if we send push notifications to the user's phone
  pushNotifications: () => i18n.pgettext('Pages|Settings', 'Push Notifications'),
  // Label on the checkbox that decides the color theme of the application
  nightMode: () => i18n.pgettext('Pages|Settings', 'Night Mode'),
  // Label on the checkbox that lets the user hide offline devices from the app
  hideOfflineDevices: () => i18n.pgettext('Pages|Settings', 'Hide Offline Devices'),
  // Label on the dropdown that decides the language of the application
  language: () => i18n.pgettext('Pages|Settings', 'Language'),
  // Label on the app version text so we can help the user diagnose issues
  appVersion: () => i18n.pgettext('Pages|Settings', 'App Version'),
};
